<template>
  <div :key="'question_'+question.uuid" class="flex-grow-1 m-2 question" v-if="question.isAuthorized()">
    <label class="fw-bolder my-2 d-flex justify-content-between" for="">
            <span :title="question.visibility" class="cursor-pointer" v-b-tooltip.hover v-if="question.visibility !== 'PUBLIC'">
                <i class="fad fa-lock text-danger"></i>
            </span>
      {{ question.label }}
      <span @click="reset" class="btn btn-xs btn-icon" v-if="hasRole('ROLE_MANAGER')">
                <i class="fad fa-trash text-danger"></i>
            </span>
    </label>
    <b-input-group
        :class="[ syncing ? 'border-secondary' : question.isValid ? 'border-success' : question.message ? 'border-danger' : 'border-light' ]"
        class="rounded border-1 d-flex flex-grow-1" style="border-style:solid">
      <b-input-group-prepend v-if="question.prefix">
        <div class="input-group-text flex-grow-1">
          <template v-if=" isIcon(question.prefix)">
            <i :class="question.prefix"></i>
          </template>
          <template v-else>
            {{ question.prefix }}
          </template>
        </div>
      </b-input-group-prepend>
      <div class="input-container flex-grow-1 rounded  d-flex">
        <input :class="{ 'rounded-left-0' : question.prefix, 'rounded-right-0' : question.suffix }"
               :regex="question.regex"
               @focus="onFocus" @blur="onBlur" @input="onInput" @keyup.enter="onBlur"
               class="fw-bolder form-control text-end" type="text" v-model="display">
        <span :title="trans('Synchronisation en cours')" class="input-status" v-b-tooltip.hover v-if="syncing">
                    <i class="fad fa-spinner-third spin text-secondary" style="text-shadow: 0 0 1px black"></i>
                </span>
        <span :title="trans(question.message)" class="input-status" v-b-tooltip.hover v-else-if="!question.isValid && question.message">
                    <i class="fad fa-exclamation-circle text-danger"></i>
                </span>
        <span class="input-status" v-b-tooltip.hover v-else-if="question.isValid">
                    <i class="fad fa-check-circle text-success"></i>
                </span>
      </div>
      <b-input-group-append v-if="question.suffix">
        <div class="input-group-text flex-grow-1">
          <template v-if=" isIcon(question.suffix)">
            <i :class="question.suffix"></i>
          </template>
          <template v-else>
            {{ question.suffix }}
          </template>
        </div>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>
<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Question from "@/entity/Question";
import {helper} from "@/services/Helper";

@Component({})
export default class Money extends Vue {
  [x: string]: any;

  @Prop() question!: Question
  display = ''
  editing = false
  to: any = null

  get syncing(): boolean {
    return this.question.response && this.question.response.synced === false
  }

  isIcon(text: string) {
    return text.match(/fa |fab |fad |fal |fas /) !== null
  }

  reset() {
    this.$store.commit('resetResponse', this.question)
    this.display = ''
  }

  // Extraire le nombre brut depuis l'affichage
  parseRaw(val: string): string {
    const raw = (val + '').replace(/\s/g, '')
    return isNaN(parseFloat(raw)) ? '' : raw
  }

  // Focus : afficher le nombre brut pour faciliter la saisie
  onFocus() {
    this.editing = true
    const raw = this.parseRaw(this.display)
    if (raw && raw !== this.display) {
      this.display = raw
    }
  }

  // Blur : formater l'affichage et sauvegarder
  onBlur() {
    this.editing = false
    const raw = this.parseRaw(this.display)
    // Écrire la valeur brute dans le store
    if (this.question.response.value !== raw) {
      this.question.response.value = raw
    }
    // Formater l'affichage
    if (raw) {
      this.display = this.helper.currencyFormat(raw, false, false)
    }
    this.question.updateAnswer()
  }

  // Frappe : écrire dans le store avec debounce, pas de reformattage
  onInput() {
    const raw = this.parseRaw(this.display)
    if (this.question.response.value !== raw) {
      this.question.response.value = raw
    }
    clearTimeout(this.to)
    this.to = setTimeout(() => {
      this.question.updateAnswer()
    }, 1500)
  }

  // Changement externe (API, reset, autre composant)
  @Watch('question.response.value')
  onResponseValueChange(newValue: any) {
    if (this.editing) return
    if (!this.helper.empty(newValue)) {
      this.display = this.helper.currencyFormat(newValue, false, false)
    } else {
      this.display = ''
    }
  }

  mounted() {
    if (this.question.response && !this.helper.empty(this.question.response.value)) {
      this.display = this.helper.currencyFormat(this.question.response.value, false, false)
    }
  }
}
</script>
<style scoped>
.input-container {
  position: relative;
}

input {
  padding-right: 30px;
}

.input-status {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
